import React from 'react';
import { BOOKING_URL, branch } from '../data/siteData';

const features = [
  { icon: '📅', title: 'Anında Onay',  desc: 'Randevunuz sisteme anında işlenir.' },
  { icon: '🔔', title: 'Hatırlatma',   desc: 'SMS ve WhatsApp ile randevu hatırlatması.' },
  { icon: '↩️', title: 'Kolay İptal',  desc: '24 saat öncesine kadar ücretsiz iptal.' },
];

const Appointment: React.FC = () => {
  return (
    <section id="appointment" className="cta-section">
      <div className="container">
        <div className="appointment-wrapper" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center' }}>

          {/* Left — info */}
          <div>
            <p style={{ fontWeight: 600, fontSize: '0.78rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.7)', marginBottom: 14 }}>
              Online Randevu
            </p>
            <h2 style={{ marginBottom: 20 }}>Randevunuzu Hemen Alın</h2>
            <p style={{ marginBottom: 32 }}>
              Bloome Beauty Batıkent randevu sistemimize yönlendirileceksiniz.
              Uygun gün, saat ve hizmeti kolayca seçebilirsiniz.
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 32 }}>
              {features.map((f) => (
                <div key={f.title} style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
                  <div style={{
                    width: 44, height: 44, borderRadius: '50%',
                    background: 'rgba(255,255,255,0.2)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '1.2rem', flexShrink: 0,
                  }}>
                    {f.icon}
                  </div>
                  <div>
                    <p style={{ color: 'white', fontWeight: 600, fontSize: '0.9rem', marginBottom: 3 }}>{f.title}</p>
                    <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.83rem', fontWeight: 300 }}>{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="cta-buttons" style={{ justifyContent: 'flex-start' }}>
              <a href={`tel:${branch.phonePlain}`} className="btn btn-ghost-light">
                📞 {branch.phone}
              </a>
              <a href={`https://wa.me/${branch.phonePlain}`} target="_blank" rel="noopener noreferrer" className="btn btn-ghost-light">
                💬 WhatsApp
              </a>
            </div>
          </div>

          {/* Right — CTA card */}
          <div>
            <div style={{
              background: '#ffffff',
              borderRadius: 24,
              padding: 48,
              boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
              textAlign: 'center',
            }}>
              <div style={{
                width: 64, height: 64,
                background: 'linear-gradient(135deg, #ff1493, #c71585)',
                borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '1.8rem', margin: '0 auto 24px',
              }}>
                📅
              </div>
              <h3 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: '1.8rem', color: '#1a1a1a', marginBottom: 10 }}>
                Randevu Al
              </h3>
              <p style={{ color: '#888', fontWeight: 300, fontSize: '0.88rem', lineHeight: 1.75, marginBottom: 32 }}>
                Resmi randevu sistemimize yönlendirileceksiniz.<br />
                Şube, hizmet ve saatinizi orada seçebilirsiniz.
              </p>
              <a
                href={BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
                style={{ display: 'block', width: '100%', borderRadius: 50, padding: '14px 30px', fontSize: '1rem', marginBottom: 12 }}
              >
                Randevu Sistemine Git →
              </a>
              <p style={{ color: '#bbb', fontSize: '0.75rem', fontWeight: 300, marginBottom: 24 }}>
                bloomebeautyclub.com/randevu.php üzerinden açılır
              </p>
              <div style={{ height: 1, background: '#f0f0f0', marginBottom: 24 }} />
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, textAlign: 'center' }}>
                {[
                  { val: '7+',   sub: 'Hizmet' },
                  { val: '1K+',  sub: 'Müşteri' },
                  { val: '4.9★', sub: 'Puan' },
                ].map((t) => (
                  <div key={t.sub}>
                    <p style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: '1.3rem', color: '#ff1493' }}>{t.val}</p>
                    <p style={{ color: '#aaa', fontSize: '0.75rem', fontWeight: 300 }}>{t.sub}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Appointment;
